import React, { FC } from "react";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

type Props = Omit<FontAwesomeIconProps, "icon">;

export const ChevronLeft: FC<Props> = (props) => (
  <FontAwesomeIcon icon={faChevronLeft} {...props} />
);
